export let ExperimentSpecs = /*#__PURE__*/function (ExperimentSpecs) {
  ExperimentSpecs["AnonymousCart"] = "specs.premium.AnonymousCart";
  ExperimentSpecs["AnonymousCartBusinessEmail"] = "specs.premium.AnonymousCartBusinessEmail";
  ExperimentSpecs["RemoveInsightWidget"] = "specs.premium.domains.removeInsightWidget_DOM2-7302";
  ExperimentSpecs["AvailableTldsModal"] = "specs.premium.domains.AvailableTldsModal";
  ExperimentSpecs["ResultsPageExactMatchHeadline"] = "specs.premium.domains.ResultsPageExactMatchHeadline";
  ExperimentSpecs["HarmonyUpgradePaywall"] = "specs.premium.domains.HarmonyUpgradePaywall";
  ExperimentSpecs["DomainsUpgradePaywallBM"] = "specs.premium.domains.DomainsUpgradePaywallBM";
  ExperimentSpecs["ResultsPageOptimizationsV41"] = "resultsPageOptimizationsV41";
  ExperimentSpecs["MatchDomainCycleToPremiumCycle"] = "matchDomainCycleToPremiumCycle";
  ExperimentSpecs["MailboxReferralBM"] = "mailboxReferralDomainsBM";
  ExperimentSpecs["WhoisProgressiveLookup"] = "whoisProgressiveLookup";
  ExperimentSpecs["WhoisMobileOptimizations"] = "whoisMobileOptimizations";
  ExperimentSpecs["LoggedInMobileConnect"] = "loggedInMobileConnectAndAssignDomains";
  ExperimentSpecs["BngTldAlternativesFromRecommendations"] = "specsPremiumDomainsBngTldAlternativesFromRecommendations";
  ExperimentSpecs["BmHarmonyTheme"] = "bmHarmonyTheme";
  ExperimentSpecs["GateRevampWithSuggestions"] = "gateRevamp31Suggestions";
  ExperimentSpecs["ExpandedGtldSuggestions"] = "enableExpandedGtldSuggestionsAB";
  ExperimentSpecs["EarlyExactMatchSuggestion"] = "domainsEarlyExactMatchSuggestion";
  ExperimentSpecs["TldPriceCache"] = "domainsGateTldPriceCache";
  ExperimentSpecs["BngResultsPageV2"] = "bngResultsPageV2";
  ExperimentSpecs["StorefrontTldStripB"] = "domainsStorefrontTldStripB";
  ExperimentSpecs["StorefrontTldStripC"] = "domainsStorefrontTldStripC";
  ExperimentSpecs["BmTldStripB"] = "domainsBmTldStripB";
  ExperimentSpecs["BmTldStripC"] = "domainsBmTldStripC";
  ExperimentSpecs["Base44ResultsOptimizations"] = "domainsBase44ResultsOptimizations";
  return ExperimentSpecs;
}({});
export const HARMONY_FLOW_QUERY_PARAM = 'harmonyFlow';
export const TLD_PREFILL_QUERY_PARAM = 'prefillTld';
export const SEARCH_QUERY_PARAMS = ['q', 'query', 'searchText', 'tlds', 'keywords', 'style', 'domainName'];
//# sourceMappingURL=constants.js.map